import styled from '@emotion/styled';
import { Variables } from '../base/variables/variables';

export const WidgetContainer = styled.div`
    position: fixed;
    top: 16px;
    right: 16px;
    z-index: 1300;
    width: min(360px, calc(100vw - 32px));
    background: ${Variables.Colors.white};
    border: 1px solid ${Variables.Colors.nx8};
    border-radius: 8px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 14px 16px;
`;

export const WidgetHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 12px;
`;

export const WidgetTitleGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 0;
`;

export const WidgetTitle = styled.span`
    font-size: 14px;
    font-weight: 600;
    color: ${Variables.Colors.n100};
`;

export const WidgetSubtitle = styled.span`
    font-size: 13px;
    color: ${Variables.Colors.n50};
`;

export const WidgetActions = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    justify-content: flex-end;
`;

export const DetailsBody = styled.div`
    padding: 0 24px 24px;
    width: 100%;
`;
